import { chooseTemplate } from '../../common/user/user.roles';
import guest from './ticket.guest.html';
import defaultTemplate from './ticket.html';

export const template = chooseTemplate({
  guest,
  defaultTemplate
});
